import { getAbTestV2 } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

export const DUTIES_ESTIMATES_V3_AB_TEST = 'dutiesEstimatesV3';

export function isDutiesEstimatesV3Variant(): boolean {
    return getAbTestV2(DUTIES_ESTIMATES_V3_AB_TEST)?.variant === 'variant';
}
